import { feetToMeters } from 'utils/distanceUtil';
import { mphToMetersPerSecond } from 'utils/speedUtil';

import {
    GROUND_SPEED_METRIC_MAX,
    OVERLAP_METERS_METRIC_MAX
} from 'pages/ApplicationDetailsPage/components/FlightPlannerPanel/components/SpraySettingsSection/constants';

import type { UseImperialHandlersParams, UseImperialHandlersReturn } from './types';

const useImperialHandlers = ({
    onUpdate
}: UseImperialHandlersParams): UseImperialHandlersReturn => {
    const handleSpeedChange: UseImperialHandlersReturn['handleSpeedChange'] = ({ value }) =>
        onUpdate({
            speedMetersPerSecond: Math.min(mphToMetersPerSecond(value), GROUND_SPEED_METRIC_MAX)
        });

    const handleOverlapChange: UseImperialHandlersReturn['handleOverlapChange'] = ({ value }) =>
        onUpdate({ overlapMeters: Math.min(feetToMeters(value), OVERLAP_METERS_METRIC_MAX) });

    return { handleOverlapChange, handleSpeedChange };
};

export default useImperialHandlers;
